import React, { useState } from "react";
import { Loader2, Upload } from "lucide-react";
import { Button } from "../ui/button";
import { handleFileChange } from "lib/uploadFile";
import { compressImage } from "lib/utils";

const UploadProfilePhoto = ({ photo, setPhoto }) => {
  const [displayUrl, setDisplayUrl] = useState(null)
  const [file, setFile] = useState("")
  const [isCompressing, setIsCompressing] = useState(false);

  const handleUpload = async (e) => {
    const nextFile = e.target.files?.[0];
    if (!nextFile) return;

    if (photo?.url) URL.revokeObjectURL(photo.url);

    try {
      setIsCompressing(true); // Start Loader
      const compressedFile = await compressImage(nextFile);

      const fileData = {
        name: compressedFile.name,
        size: (compressedFile.size / 1024 / 1024).toFixed(1) + " mb",
        file: compressedFile,
        url: URL.createObjectURL(compressedFile),
      };
      setPhoto(fileData);

    } catch (error) {
      console.error("Processing failed:", error);
      const fallbackData = {
        name: nextFile.name,
        size: (nextFile.size / 1024 / 1024).toFixed(2) + " MB",
        file: nextFile,
        url: URL.createObjectURL(nextFile),
      };
      setPhoto(fallbackData);
    } finally {
      setIsCompressing(false);
    }
  };

  return (
    <div className="w-full border rounded-2xl p-6 bg-card shadow-sm">
      <h2 className="text-base font-bold mb-5">Profile Photo</h2>

      <div className="flex flex-col items-center justify-center gap-3 border border-dashed border-gray-300 rounded-xl p-6">

        {
          isCompressing ? (
            <>
              <Loader2 size={20} className="animate-spin" />
              <span className="text-button-generic-foreground  text-sm">Optimizing photo...</span>
            </>
          ) : (
            <>
              {!photo ? (
                <>
                  <Upload size={20} />
                  <span className="text-button-generic-foreground  text-sm">Upload Profile Photo</span>
                </>
              ) : (
                <div className="flex flex-col items-center gap-2">
                  <img
                    // src={displayUrl}
                    src={photo.url}
                    alt="uploaded profile"
                    className="w-24 h-24 rounded-full object-cover border"
                  />
                  <span
                    className="text-sm font-medium text-center"
                    title={photo.name}
                  >
                    {photo.name}
                  </span>
                </div>
              )}
            </>
          )
        }


        <Button
          asChild
          disabled={isCompressing}
          className="cursor-pointer bg-button-coloured text-sm border px-4 py-2 mt-2"
        >
          <label>
            {isCompressing ? "Uploading..." : (!photo ? "Choose Photo" : "Upload Another Photo")}
            <input
              type="file"
              accept="image/png,image/jpeg"
              className="hidden"
              onChange={handleUpload}
              disabled={isCompressing}
            />
          </label>
        </Button>

      </div>
    </div>
  );
};

export default UploadProfilePhoto;
